// Real Supabase Auth — email + password. No magic link, no OTP, no
// sign-up. Admins provision accounts through the Supabase dashboard.
// The sign-in form itself lives in shared-gov as `AppLoginCard`.
export const login = {
  extends: 'Page',
  metadata: { title: 'Sign in / Symbols Workspace' },
  flow: 'y',
  align: 'center center',
  padding: 'D C',
  width: '100%',
  minHeight: '100dvh',
  maxWidth: 'none',

  LoginCard: {
    extends: 'AppLoginCard',
    eyebrow: 'Sign in',
    title: 'Welcome back',
    sub: 'Sign in to your workspace with your email and password.',
    redirectTo: '/'
  }
}
